import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Site } from '@classes/site';
import { SiteDetail } from '@classes/site-detail';
import { SiteService } from 'app/core/services/site.service';
import { SiteDetailComponent } from 'app/modules/site/components/site-detail/site-detail.component';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss']
})
export class SiteListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredSites();
    }
  }
  @Input() placeHolder: string;
  @Input() pacoOnly: boolean = false;
  @Input() displayAddButton: boolean = false;

  myControl!: FormControl;

  sites: Site[] = [];
  filteredSites: Observable<Site[]> | undefined;

  constructor(
    public siteService: SiteService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this._refreshList();
    this._initList();
  }

  private _initList(refresh?: boolean) {
    this.siteService.sites.subscribe(sites => {
      this.sites = sites.filter(f => this.pacoOnly ? f.isPaco : true)
        .sort((a, b) => ((a.name || "").toLowerCase() > (b.name || "").toLowerCase()) ? 1 : (((b.name || "").toLowerCase() > (a.name || "").toLowerCase()) ? -1 : 0));;
      this._initFilteredSites();
    }, error => {
      console.error(error);
    })
  }

  private _refreshList(){
    this.siteService.getSites(true).subscribe();
  }

  private _initFilteredSites(): void {
    if (this.myControl) {
      this.filteredSites = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return []
          })
        );
    }
  }

  private _filter(value: string): Site[] {
    const filterValue = value.toLowerCase();
    return this.sites.filter(option =>
      (option.name || '').toLowerCase().includes(filterValue)
      || (option.address?.address1 || '').toLowerCase().includes(filterValue)
      || (option.address?.address2 || '').toLowerCase().includes(filterValue)
      || (option.address?.city || '').toLowerCase().includes(filterValue)
      || (option.address?.country || '').toLowerCase().includes(filterValue)
      || (option.address?.zip?.toString() || '').toLowerCase().includes(filterValue)
    );
  }

  displayFn(site?: Site): string {
    return site ? (site.name || '') : '';
  }

  createSite() {
    const data = new SiteDetail({
      isCreationMode: true
    });
    const dialogRef = this.dialog.open(SiteDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value && value.success) {
        this._refreshList();
        this.myControl.setValue(value.data);
      }
    });
  }

}
  